// NodeTemporalReadOnlyValue.jsx — calendar icon + friendly temporal label

import React, { useMemo } from 'react';

import { useTheme } from 'context/ThemeContext';
import Icon from 'svg/Icon';
import { formatNodeTemporalDisplay } from 'node/form/fields/utilities/nodeTemporalDisplay';

import './NodeTemporalReadOnlyValue.css';

/**
 * Read-only temporal display for visitor Peek / previewMode.
 *
 * @param {unknown} value - Stored field value.
 * @param {'date'|'datetime'|'daterange'|'datetimerange'|'annualdate'} fieldType
 * @param {string} [iconKey='calendar_month']
 */
const NodeTemporalReadOnlyValue = React.memo(({
  value,
  fieldType,
  iconKey = 'calendar_month',
}) => {
  const { theme } = useTheme();

  const label = useMemo(
    () => formatNodeTemporalDisplay(value, fieldType),
    [fieldType, value],
  );

  if (!label) return null;

  return (
    <div className="node-temporal-readonly">
      <span className="node-temporal-readonly-icon">
        <Icon
          iconKey={iconKey}
          color={theme.foregroundMuted}
          width={22}
          height={22}
        />
      </span>
      <span className="node-temporal-readonly-label">
        {label}
      </span>
    </div>
  );
});

NodeTemporalReadOnlyValue.displayName = 'NodeTemporalReadOnlyValue';

export default NodeTemporalReadOnlyValue;
